module.exports = __webpack_public_path__ + "static/img/剪纸2.c1ad309.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/剪纸2.svg
// module id = 2oM2
// module chunks = 2